import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { whiteLabelPartnersService } from 'src/services/white-label-partners.service'
import {
  IUpdateWhiteLabelPartnerDto,
  ICreateWhiteLabelPartnerDto,
} from 'src/types/white-label-partners.type'

interface IProps {
  id: string
  item: IUpdateWhiteLabelPartnerDto
}

const useUpdateWhiteLabelPartner = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ id, item }: IProps) => {
      const updatedItem: ICreateWhiteLabelPartnerDto = {
        name: item.name || '',
        primary_color: item.primary_color || '',
        secondary_color: item.secondary_color || '',
        alternative_color: item.alternative_color || '',
        logo: item.logo || '',
        qr_code_logo: item.qr_code_logo || '',
        journey_link: item.journey_link || '',
        footer: item.footer || '',
        footer_url: item.footer_url || '',
        footer_color: item.footer_color || '',
        billing_hidden: item.billing_hidden || false,
      }

      return whiteLabelPartnersService.updateWhiteLabelPartner(id, updatedItem)
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.WHITE_LABEL_PARTNERS)

          queryClient.refetchQueries(QUERY_KEYS.ACCOUNT)
        }
      },
    },
  )
}

export { useUpdateWhiteLabelPartner }
